define([
	'internal_util/Util',
	'model/ActivationType',
	'state/UIState',
	'service/UIStateManager',
	'service/EventListenerRegistry',
	'factory/AuthenticationOptionsFactory',
	'factory/AuthenticationOptionGroupsFactory',
	'view/ProviderInfoView',
	'view/NavigationView',
	'view/ControlView',
	'view/ControlBarView',
	'view/TextView',
	'amdi18n-loader?!state/nls/UIState_strings',
	'amdi18n-loader?!state/nls/IdentitiesOverviewState_strings'
], function (
	Util,
	ActivationType,
	UIState,
	UIStateManager,
	EventListenerRegistry,
	AuthenticationOptionsFactory,
	AuthenticationOptionGroupsFactory,
	ProviderInfoView,
	NavigationView,
	ControlView,
	ControlBarView,
	TextView,
	CommonStrings,
	Strings
) {
	'use strict';

	/**
	 * IdentitiesOverviewState class
	 */
	function IdentitiesOverviewState(uiStateManager) {
		var _uiStateManager,
			_providerInfoView = new ProviderInfoView(),
			_navigationView = new NavigationView(),
			_controlView = new ControlView(authenticationOptionClickHandler),
			_controlBarView = new ControlBarView('skIdS_control-bar-identity-overview'),
			_noIdentitiesTextView,
			_identities = null;

		if (uiStateManager instanceof UIStateManager) {
			_uiStateManager = uiStateManager;
		} else {
			throw new Error('no valid uiStateManager found');
		}

		_navigationView.update(Strings.available_cloud_ids);

		_noIdentitiesTextView = (function () {
			var textView = new TextView();

			textView.addText(Strings.no_cloud_identity_available);
			textView.addNewLine(2);
			textView.addLink(Strings.add_now, function () {
				_uiStateManager.change('identity_creation');
			});

			return textView;
		})();

		if (_uiStateManager.core().contextChangeable()) {
			_controlBarView.addButton(CommonStrings.back, function () {
				_uiStateManager.changeContext();
			}, 0);

			_controlBarView.addButtonDropup([ Strings.add_id, Strings.revoke_ids ], [
				function () {
					_uiStateManager.change('identity_creation');
				}, function () {
					_uiStateManager.change('identities_revokation');
				}
			]);
		} else {
			_controlBarView.addButtonDropup([ Strings.add_id, Strings.revoke_ids ], [
				function () {
					_uiStateManager.change('identity_creation');
				}, function () {
					_uiStateManager.change('identities_revokation');
				}
			], 0);
		}

		_controlBarView.addButton(CommonStrings.abort, function () {
			_uiStateManager.abort();
		});

		UIState.call(this, 'identities_overview');


		// private methods

		function authenticationOptionClickHandler(authenticationOption) {
			var identity = _uiStateManager.core().cloudIdentitiesManager().getIdentityByAuthenticationOptionUi(authenticationOption);
                        _uiStateManager.change('identity_management', { identity : identity });
//			if (identities.length === 1) {
//				_uiStateManager.change('identity_management', { identity : identities[0] });
//			} else {
//				// TODO: implement choosing cloud identity (by popover)
//			}
		}


		// public methods

		this.title = function () {
			return _uiStateManager.core().cloudIdentitiesManager().providerInfo().description();
		};
		
		this.poweredByImage = function () {
			if (_uiStateManager.core().optionsManager() === null || _uiStateManager.core().optionsManager() === undefined) {
				return null;
			}
			return _uiStateManager.core().optionsManager().providerInfo().poweredByImage();
		};

		this.content = function () {
			return [ _providerInfoView, _navigationView, _controlView ];
		};

		this.controls = function () {
			return _controlBarView;
		};

		this.enter = function (doneCallback, data) {
			var cloudIdentitiesManager = _uiStateManager.core().cloudIdentitiesManager(),
				i;

			_identities = cloudIdentitiesManager.identities();

			_providerInfoView.update(cloudIdentitiesManager.providerInfo());
                        
			var authenticationOptions = cloudIdentitiesManager.getAuthenticationOptionsUiByIdentities(_identities);
                        
			_controlView.update(authenticationOptions, _noIdentitiesTextView);

			for (i = 0; i < _identities.length; i++) {
				var authOp = cloudIdentitiesManager.getAuthenticationOptionsUiByIdentities(_identities[i])[0];
				if (!_identities[i].isEnabled()) {
					_controlView.disableAuthenticationOption(authOp,true);
					_controlView.enableAuthenticationOptionToolTip(authOp, Strings.cloud_identity_deactivated);
				} else if (!cloudIdentitiesManager.isUsableIdentityByAuthenticationOption(_identities[i])) {
					_controlView.disableAuthenticationOption(authOp,true);
					_controlView.enableAuthenticationOptionToolTip(authOp, Strings.cloud_identity_insufficient);
				}
			}

			Util.callCallbacks(doneCallback);
			
			
			//Skip overview state and go to management state
			var renew = false,
				deletedCloudId = false;
			
			if (data) {
				renew = data.renew ? data.renew : false;
				deletedCloudId = data.deletedCloudId ? data.deletedCloudId : false;;
				
//				var authenticationOption = null;
//				if (data['renew'].hasOwnProperty('authenticationOptions')) {
//					authenticationOption = AuthenticationOptionGroupsFactory.createFromObject(authenticationOption);
//				} else {
//					authenticationOption = AuthenticationOptionsFactory.createFromObject(authenticationOption);
//				}
			}
			
			if (_identities.length > 0) {
				_uiStateManager.change('identity_management', { identity : _identities[0], renew : renew });
			} else {
				_uiStateManager.change('identity_management', {deletedCloudId : deletedCloudId});
			}
			

		};

		this.leave = function (doneCallback) {
			_identities = null;

			Util.callCallbacks(doneCallback);
		};
	};

	IdentitiesOverviewState.prototype = Object.create(UIState.prototype);

	return IdentitiesOverviewState;
});


//////////////////
// WEBPACK FOOTER
// ./src/main/web/js/app/state/IdentitiesOverviewState.js
// module id = 329
// module chunks = 3